export default [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/pages/LoginPage')
    },
    {
        path: '/',
        component: () => import('@/pages/HomePage'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/pages/HomeLandingPage')
            },
            {
                path: 'bookings',
                name: 'BookingList',
                component: () => import('@/pages/BookingListPage')
            },
            {
                path: 'ticketAndAddOn',
                name: 'TicketAndAddOn',
                component: () => import('@/pages/ProductListPage')
            },
            {
                path: 'andamanda-pay',
                name: 'AndamandaPay',
                component: () => import('@/pages/AndamandaPayListPage')
            },
            {
                path: 'tickets-visibility',
                name: 'TicketVisibility',
                component: () => import('@/pages/TicketVisibilityPage')
            },
            {
                path: 'banners/top-menus',
                name: 'TopBannerSetting',
                component: () => import('@/pages/TopBannerSettingListPage')
            },
            {
                path: 'banners/promotions',
                name: 'PromotionSetting',
                component: () => import('@/pages/PromotionSettingListPage')
            },
            {
                path: 'ibeacon/messages',
                name: 'IBeaconMessageList',
                component: () => import('@/pages/IBeaconMessageListPage')
            },
            {
                path: 'ibeacons',
                name: 'IBeaconList',
                component: () => import('@/pages/IBeaconListPage')
            },
            {
                path: 'team-building/events',
                name: 'EventList',
                component: () => import('@/pages/EventListPage')
            },
            {
                path: 'team-building/customers',
                name: 'CustomerGroupList',
                component: () => import('@/pages/CustomerGroupListPage')
            },
            {
                path: 'team-building/participants',
                name: 'ParticipantList',
                component: () => import('@/pages/ParticipantListPage')
            },
            {
                path: 'team-building/staffs',
                name: 'StaffList',
                component: () => import('@/pages/StaffListPage')
            },
            {
                path: 'treasure-hunt',
                component: () => import('@/pages/TreasurePage'),
                children: [
                    {
                        path: '',
                        name: 'TreasureHunt',
                        component: () => import('@/pages/TreasureHuntPage')
                    },
                    {
                        path: 'redeem/:gameId',
                        name: 'RedeemTreasure',
                        component: () => import('@/pages/RedeemTreasurePage')
                    }
                ]
            },
            {
                path: 'customers',
                name: 'CustomerList',
                component: () => import('@/pages/CustomerListPage')
            },
            {
                path: 'sale-agents-by-category',
                name: 'SaleAgentByCategory',
                component: () => import('@/pages/SaleAgentByCategoryListPage')
            },
            {
                path: 'sale-agents-by-person',
                name: 'SaleAgentByPerson',
                component: () => import('@/pages/SaleAgentByPersonListPage')
            },
            {
                path: 'sale-agent-requests',
                name: 'SaleAgentRequest',
                component: () => import('@/pages/SaleAgentRequestListPage')
            },
            {
                path: 'andamanda-staffs',
                name: 'AndamandaStaffList',
                component: () => import('@/pages/AndamandaStaffListPage')
            }
        ]
    }
]
